var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdherence({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6902 11.9859C18.4186 11.9897 19.8066 10.5372 19.8106 8.73404C19.8146 6.93086 18.4331 5.47219 16.7047 5.46835C14.9764 5.4645 13.578 6.91698 13.574 8.72016C13.57 10.5233 14.9619 11.982 16.6902 11.9859ZM8.36087 11.9673C10.0892 11.9712 11.4772 10.5187 11.4812 8.71551C11.4852 6.91232 10.1037 5.45366 8.37538 5.44981C6.64703 5.44597 5.24863 6.89844 5.24461 8.70163C5.2406 10.5048 6.63253 11.9635 8.36087 11.9673ZM8.35604 14.1399C5.93011 14.1345 1.06502 15.3946 1.05939 17.9255L1.05335 20.6412L15.6297 20.6736L15.6358 17.958C15.6414 15.427 10.782 14.1453 8.35604 14.1399ZM16.6854 14.1584C16.3835 14.1577 16.0398 14.1787 15.6753 14.2105C16.8811 15.1256 17.7217 16.3549 17.7181 17.9626L17.7121 20.6782L23.9591 20.6921L23.9651 17.9765C23.9708 15.4455 19.1113 14.1638 16.6854 14.1584Z",
    fill: "#6D5FF2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdherence);
export default __webpack_public_path__ + "static/media/adherence.80999e17a2d77aea817e9755f1c206de.svg";
export { ForwardRef as ReactComponent };